class FormCaptcha {
  constructor() {
    this.recaptchaKey = '6LftmM4ZAAAAAK6ba2XzybJ3X1R6FYTQybfn9Rv8';
    this.init();
  }

  init() {
    const element = document.querySelector('.js-captcha');
    if (element !== null) {
      element.addEventListener('submit', () => {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.recaptchaKey, { action: 'submit' });
        });
      });
    }
  }
}

export default FormCaptcha;
